import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { PositionCodeDto, DropDownPositionCodesStore } from 'stores/configuration/profiles/position-codes-store';
import { nameof } from 'utils/object';
import TailwindSelect from 'widgets/editors/tailwind-select';

interface TailwindPositionCodeEditorProps extends WithTranslation {
  value: string;
  onChange: (value: PositionCodeDto) => void;
  placeholder?: string;
  positionCodes?: DropDownPositionCodesStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  clearable?: boolean;
  className?: string;
  inline?: boolean;
  readonly?: boolean;
  showDescription?: boolean;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
}

interface TailwindPositionCodeEditorState {
  value: string;
  availablePositionCodes: { [id: string]: PositionCodeDto };
  positionCodeOptions: { text: string; value: string }[];
  isLoading: boolean;
}

@connect(['positionCodes', DropDownPositionCodesStore])
class TailwindPositionCodeEditor extends React.Component<TailwindPositionCodeEditorProps, TailwindPositionCodeEditorState> {
  private get positionCodeStore() {
    return this.props.positionCodes;
  }

  private get placeHolderPros() {
    const { t } = this.props as any;

    if (this.props.placeholder) {
      return this.props.placeholder;
    } else {
      return t('Select PositionCode');
    }
  }

  private get classNamePros() {
    if (this.props.className) {
      return this.props.className;
    } else {
      return 'planit-users-inputs planit-user-dropdown planit-user-selector planit-user-selector__position-code';
    }
  }

  constructor(props: TailwindPositionCodeEditorProps) {
    super(props);
    this.state = {
      value: this.props.value,
      availablePositionCodes: {},
      positionCodeOptions: [],
      isLoading: false
    };

    this.initPositionCodes();
  }

  UNSAFE_componentWillReceiveProps(next: TailwindPositionCodeEditorProps) {
    if (next !== this.props && next.value !== this.props.value && (next.value == null || this.props.value == null)) {
      this.setState({
        value: next.value
      });
      this.initPositionCodes();
    }
  }

  private async initPositionCodes() {
    try {
      this.setState({ isLoading: true });
      return await this.positionCodeStore
        .getAllAsync({
          searchQuery: '',
          skip: 0,
          take: 100000,
          orderBy: [{ direction: 'Ascending', field: nameof<PositionCodeDto>('code'), useProfile: false }]
        })
        .then(positionCodes => {
          const dict = {};
          const options = [];

          positionCodes.items.forEach(posCode => {
            dict[posCode.id] = posCode;
            options.push({ text: this.props.showDescription ? posCode.description : posCode.code, value: posCode.id });
          });

          this.setState({
            availablePositionCodes: dict,
            positionCodeOptions: options
          });
        });
    } catch (error) {
      console.error('Error loading locations:', error);
      this.setState({ availablePositionCodes: {}, positionCodeOptions: [] });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  public render() {
    const { t } = this.props;
    const { isLoading, positionCodeOptions } = this.state;

    return (
      <TailwindSelect
        options={
          isLoading
            ? [{ id: 'loading', text: t('Loading...'), disabled: true }]
            : positionCodeOptions.length > 0
            ? positionCodeOptions.map(by => ({
                id: by.value,
                text: by.text
              }))
            : [{ id: 'no-options', text: t('No options available'), disabled: true }]
        }
        value={this.state.value ?? null}
        //onChange={this.handleOnChange}
        onChange={data => this.selectedPositionCode(data)}
        placeholder={this.placeHolderPros}
        clearable
        searchable={!this.state.isLoading}
        disabled={this.props.readonly}
        className="w-full"
      />
    );
  }

  selectedPositionCode(data: any) {
    this.setState({
      value: data.value
    });

    this.props.onChange(this.state.availablePositionCodes[data.value]);
  }
}

export default withTranslation()(TailwindPositionCodeEditor);
